// extracted by mini-css-extract-plugin
export default {"li":"DotList_li_ad21e"};